import { useState, useEffect, useCallback } from 'react'
import * as umServiceURL from './umServiceURL'
import useCallApi from '../../utilities/axios'

export type HoldKeywordType = {
    userID: number | null
    keyword?: string
    projectType?: string | null
    startDate: string | Date
    endDate: string | Date
}

export type HoldDataListType = {
    projectID: number
    receiveDate: string
    projectNumber: string
    projectName: Translation
    projectType: {
        id: number
        name: Translation
    }
    name: Translation
    title: Translation
    academicPosition: Translation
    researcherTypeName: Translation
    facultyName: Translation
    degree: Translation
    countDueDate: number
}

type Translation = {
    th: string
    en: string
}

export type DataRowsType = {
    id: number
    projectNumber: string
    receiveDate: string
    researcherName: string
    degree: string
    projectNameTH: string
    projectNameEN: string
    projectType: string
    faculty: string
    researcherTypeName: string
    countDueDate: number
}

export const useSearchHold = () => {
    const [dataList, setDataList] = useState<HoldDataListType[]>([])

    const callApi = useCallApi()

    const searchHold = useCallback(async (values?: HoldKeywordType) => {
        if (values?.userID) {
            const { data } = await callApi.axiosPost({
                url: umServiceURL.postSearchHold,
                params: values,
            })

            setDataList(data)
        }
    }, [])

    useEffect(() => {
        searchHold()
    }, [searchHold])

    return {
        dataList,
        setDataList,
        searchHold,
    }
}
